"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("../http");
const serializeOutcomingOrder_1 = __importDefault(require("./serializeOutcomingOrder"));
const deserializeOutcomingOrder_1 = __importDefault(require("./deserializeOutcomingOrder"));
const putOutcomingOrderById = async ({ axios, outcomingOrderId, outcomingOrder }) => {
    const { data } = await http_1.httpPut({
        axios,
        url: `outcoming-order/${outcomingOrderId}`,
        data: serializeOutcomingOrder_1.default(outcomingOrder, true)
    });
    return deserializeOutcomingOrder_1.default(data);
};
exports.default = putOutcomingOrderById;
